<template>
    <div>
        <!-- 因为设置了可多选上传，上传前handleChange方法怎么判断上传的数量？ -->
        <p id="titleName">
            <span style="color: #00A5D5;">{{secTitle}}</span>
            <span v-if="content!=''">（{{content}}）</span>
        </p>
        <!-- 上传文件 -->
        <div>
            <div class="orderUpload">
                <el-upload v-for="(item,i) in list" :key="i" drag action :show-file-list="false"
                    :before-upload="handleChange" :http-request="uploadFile" class="tempUpload" multiple
                    :style="draggerStyle" :data="{objectType:dataType,objectTag:'',index:i}" :auto-upload="true">
                    <i class="el-icon-close" v-if="dataList[i]" @click.stop="removeFile(i)"></i>
                    <div class="removeIcon" v-if="dataList[i]">
                        <i class="el-icon-check"></i>
                    </div>
                    <img v-if="dataList[i]" :src="dataList[i]" class="avatar">
                    <div v-else>
                        <i class="el-icon-plus uploadIcon"></i>
                        <div class="el-upload__text"><em>{{ item.label }}</em></div>
                    </div>
                </el-upload>
            </div>
            <h2 id="example" @click="isShow=!isShow">示例</h2>
            <!-- 示例图片 -->
            <transition name="el-fade-in-linear">
                <div v-show="isShow" class="item">
                    <div class="example" v-for="(item,i) in list" :key="i" :style="{marginLeft:distance+'%'}">
                        <img class="exampleImg" :src="item.imgUrl" alt="item.label"
                            :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }">
                        <img class="copyright" :style="list.length == 5 ? 'bottom:50px;' : ''" v-if="list.length == 4 && isShow"
                            src="/static/images/orthodontics/smiling-orthodontics.jpg">
                        <img class="copyright" :style="list.length == 5 ? 'bottom:50px;' : ''" v-if="list.length == 5 && isShow&&![0,4].includes(i)"
                            src="/static/images/orthodontics/smiling-orthodontics.jpg">
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import EleUploadImage from "vue-ele-upload-image";
import BaseTag from '../../../components/BaseTag'
import {
    uploadByPieces
  } from "../../../../common/upload.js";

export default {
    data(){
        return {
            fileList:[],//temp存储文件集合
            dataList:[],
            imageUrl: '',
            distance:0,//图片盒子间距
            uploadDistance:0,//图片上传框间距
            imgWidth:150,//图片宽度
            imgHeight:220,//图片高度
            titleName:'',
            secTitle:'',
            content:'',
            isShow:false,//是否显示示例图片
            marginLeft:'',//间距
            widthImg:'',//图片对应宽度
            heightImg:'',//图片对应高度
            marginTop:'',//icon上边距
        }
    },
    props:{
        subCatalogId:{
            type:String,
            default:''
        },
        form:{
            type:Object,
            default(){
                return {}
            }
        },
        list:{
            type:Array,
            default(){
                return {}
            }
        },
        isEditServOrder:{
            type:String,
            default:'0'
        },
        currentStep:{
            type:Number,
            default:0
        },
        dataType:{
            type:String,
            default:''
        }
    },
    computed: {
        draggerStyle() {
            return {
                '--widthImg': this.widthImg,
                '--heightImg': this.heightImg,
                '--marginLeft': this.marginLeft,
                '--marginTop': this.marginTop,
            };
        }
    },
    methods:{
        changeShow(){
            this.isShow = !this.isShow
        },
        handleChange(label) {
            const isImageByType  = label.type.startsWith('image/');
            const isImageByExt = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp', 'ico'].includes(label.name.split('.').pop().toLowerCase());
            const isImage = isImageByType || isImageByExt;
            if (!isImage) {
                this.$message.error('只能上传图片文件!');
                return false;
            }
            // if(this.dataList.length>=4){
            //     this.$message.error('请先移除一张图片!');
            //     return false;
            // }
        },
        removeFile(index){
            let arr = []
            this.dataList.forEach((el,i) => {
                if(i!=index){
                    arr.push(el)
                }
            });
            this.dataList = arr
            if (this.list.length == 4) {
                sessionStorage.setItem('dataFaceList', JSON.stringify(this.dataList));
            } else {
                sessionStorage.setItem('dataMouthList', JSON.stringify(this.dataList));
            }
        },
        uploadFile({response,file,data}) {
            // console.log('res:',response,'file:',file,'data:',data)
            var loading = this.$loading({ text: '等待上传完成，已上传0%' })
            var that = this
            uploadByPieces({
                file: file,//文件
                data: data,
                pieceSize: 3,
                concurrent: 3,
                process: res => {
                    loading.setText('等待上传完成，已上传' + res + '%')
                    if (res == 100) {
                        loading.close();
                    }
                },
                success: res => {
                    this.dataList.push(res.data.url);
                    // list.length判断是口内还是面像照
                    if (this.list.length == 4) {
                        sessionStorage.setItem('dataFaceList', JSON.stringify(this.dataList));
                    } else {
                        sessionStorage.setItem('dataMouthList', JSON.stringify(this.dataList));
                    }
                    loading.close();
                    this.transFile();
                },
                error: e => {
                    console.log('e', e)
                }
            })
        },
        transFile(){
            this.$emit('transFile',this.dataList,this.dataType)
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      handlePictureCardPreview(){

      },
      handleRemove(){

      },
      showStr(){
        this.titleName = '隐形矫治';
        if(this.list.length==4){
            this.secTitle = '面像照';
            this.content = '拍照要求：摘下佩戴饰品，整理头发，可见两侧耳廓，两眼平视前方与地面平行，自然放松，鼻梁位于正中，下可见锁骨。';
            this.uploadDistance = 8.33333
            this.distance = 8.33333
            this.imgWidth = 170;
            this.imgHeight = 220;
        }else if(this.list.length==5){
            this.secTitle = '口内照';
            this.content = '';
            this.imgWidth = 220;
            this.imgHeight = 170;
            this.uploadDistance = 6.1
            this.distance = 0.5
        }else if(this.list.length==2){
            this.secTitle = '影像资料';
            this.content = '头颅侧位片拍摄位置要求：最大牙尖交错位。';
            this.list=[
                {label:'曲面断层片（全景片）',imgUrl:'/static/images/orthodontics/bone1.png'},
                {label:'头颅侧位片',imgUrl:'/static/images/orthodontics/bone2.png'},
            ]
        }
        if (this.list.length == 4) {
            this.widthImg = '150px';
            this.heightImg = '190px';
            this.marginLeft = '112px';
            this.marginTop = '70px';
        } else {
            this.widthImg = '210px';
            this.heightImg = '170px';
            this.marginLeft = '20px';
            this.marginTop = '60px';
        }
      },
      loadJSONSession(key,defaultValue){
        const value = JSON.parse(sessionStorage.getItem(key));
        return value !== null ? value : defaultValue;
      },
      loadSessionFile(){
        let val = '';
        if (this.list.length == 4) {
            val = this.loadJSONSession('dataFaceList', this.dataList);
        } else {
            val = this.loadJSONSession('dataMouthList', this.dataList);
        }
        this.dataList = val
        this.transFile();
      }
    },
    watch:{
        currentStep(oldVal,newVal){
            this.showStr()
        }
    },
    created(){
    },
    mounted(){
        this.showStr();
        this.loadSessionFile();
    },
    components:{
        EleUploadImage,
        BaseTag
    }
}
</script>
<style lang="scss" scoped>
#titleName{
    // position: relative;
    margin:5px 0 0 30px;
    font-weight:500;
    font-size: 15px;
}
.orderUpload{
    height: 200px;
    margin-top: 20px;
    display: flex;
}

#example{
    font-size:18px;
    font-weight:700;
    text-align:center;
    color:#00A5D5;
    margin:10px 0 10px 0;
}

.avatar{
    width:100%;
    height:100%;
}

/* create上传 */

.item{
    width: auto;
    height: 220px;
    margin: 0 auto;
    display: flex;
}
.example{
    justify-content: space-between;
    position: relative;
    .exampleImg{
        z-index: 50;
        width: 150px;
        height: 220px;
    }
    .copyright{
        width: 30px;
        height: 30px;
        position: absolute;
        bottom: 1px;
        right: 0px;
        z-index: 99;
    }
}


.uploadIcon{
    font-size: 30px;
    margin-top: var(--marginTop);
    margin-bottom: 30px;
}

.tempUpload{
    position: relative;
    overflow: hidden;
    .removeIcon{
        width: 40px;
        height: 40px;
        transform: rotate(45deg);
        background: #13CE66;
        position: absolute;
        right: -20px;
        top: -20px;
        z-index: 99;
        color: white;
        .el-icon-check{
            margin-top: 25px;
            transform: rotate(-45deg);
        }
    }
}
.el-icon-close{
    position: absolute;
    right: -20px;
    top: 2px;
    display: block;
    width: 54px;
    height: 54px;
}
.el-icon-close:hover{
    color: red;
    z-index: 100;
}
.tempUpload:hover{
    .removeIcon,.el-icon-check{
        display: none;
    }
    .el-icon-close{
        display: block;
    }
}
</style>
<style>
.tempUpload .el-upload-dragger{
    width: var(--widthImg);
    height: var(--heightImg);
    margin-left: var(--marginLeft);
}
</style>



// WEBPACK FOOTER //
// templateUpload.vue?052680be